export default [{
    path: '/index',
    name: 'index',
    meta: {
      index: 1,
      title: '邀请开店'
    },
    component: () => import('@/views/invite-page/index.vue')
  },
  {
    path: '/shop',
    name: 'shop',
    meta: {
      index: 1,
      title: '开店信息',
      keywords: "吉祥有约可以限时免费开店啦~",
      description: "限时获取美容院营销商城与店务管理系统一套",
      // image: 'http://dlcn.mikecrm.com/ugc_4_a/pub/o1/o1oak4khytbdbekl5rucm0zl6qcjntj7/form/image/M0iNQMC4vwMXPm5VziRIjGyFAOZiL50p.png'
    },
    component: () => import('@/views/shop-info/index.vue')
  },
  {
    path: '/maker',
    name: 'maker',
    meta: {
      index: 1,
      title: '创客入驻吉祥有约',
      // image: 'http://dlcn.mikecrm.com/ugc_4_a/pub/o1/o1oak4khytbdbekl5rucm0zl6qcjntj7/form/image/M0iNQMC4vwMXPm5VziRIjGyFAOZiL50p.png'
    },
    component: () => import('@/views/shop-info/maker-form.vue')
  },
  {
    path: '/preview',
    name: 'preview',
    meta: {
      index: 1,
      title: '预览'
    },
    component: () => import('@/views/new-details/index.vue')
  },
  {
    path: '/diagnosis',
    name: 'diagnosis',
    meta: {
      index: 1,
      title: '经营诊断'
    },
    component: () => import('@/views/diagnosis/index.vue')
  },
  {
    path: 'downapk',
    name: 'downapk',
    meta: {
      index: 1,
      title: '下载App'
    },
    component: () => import('@/views/h5-down/index.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      index: 1,
      title: '服务协议'
    },
    component: () => import('@/views/privacy-agreement/index.vue')
  },
  {
    path: '/guide-page',
    name: 'guidePage',
    meta: {
      index: 1,
      title: '引导页'
    },
    component: () => import('@/views/privacy-agreement/guide-page.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    meta: {
      index: 1,
      title: '隐私政策'
    },
    component: () => import('@/views/privacy-agreement/policy.vue')
  },
  {
    path: '/wechat-code',
    name: 'wechat-code',
    meta: {
      index: 1,
      title: '分享App'
    },
    component: () => import('@/views/wechat-code/index.vue')
  },
  {
    path: '/long-picture',
    name: 'long-picture',
    meta: {
      index: 1,
      title: '百万美容院数智经营方案'
    },
    component: () => import('@/views/long-picture/picture.vue')
  },
  {
    path: '/file-download',
    name: 'file-download',
    meta: {
      index: 1,
      title: '吉祥有约资料库'
    },
    component: () => import('@/views/file-download/index.vue')
  },
  {
    path: '/course-info',
    name: 'course-info',
    meta: {
      index: 1,
      title: '课程信息'
    },
    component: () => import('@/views/course-info/index.vue')
  },
  {
    path: '/renewal-upgrade',
    name: 'renewal-upgrade',
    meta: {
      index: 1,
      title: '续费升级'
    },
    component: () => import('@/views/renewal-upgrade/index.vue')
  },
  {
    path: '/register-guide',
    name: 'register-guide',
    meta: {
      index: 1,
      title: '注册'
    },
    component: () => import('@/views/register-guide/index.vue')
  },
  {
    path: '/register-maker',
    name: 'register-maker',
    meta: {
      index: 1,
      title: '创客入驻吉祥有约'
    },
    component: () => import('@/views/register-guide/maker.vue')
  },
  {
    path: '/buy',
    name: 'Buy',
    meta: {
      index: 1,
      title: ''
    },
    component: () => import('@/views/buy/index.vue')
  },
  {
    path: '/screen',
    name: 'screen',
    meta: {
      index: 1,
      title: '数据看板'
    },
    component: () => import('@/views/screen/screen-index.vue')
  }
]
